import { Component, ContentChildren, Input, QueryList, TemplateRef } from '@angular/core';

@Component({
  selector: 'split-total-table',
  templateUrl: './split-total-table.component.html',
  styleUrls: ['./split-total-table.component.scss']
})
export class SplitTotalTableComponent {
    @ContentChildren('column') columns!: QueryList<TemplateRef<any>>;

    @Input() data: any = [];
    @Input() widthColumns: Array<number> = [];
}
